export default __webpack_public_path__ + "static/media/statystyki-1.9c484c27.png";